import React from "react";

const testimonials = [
  {
    quote: "After looking at five different places, Hillcrest was the only one that felt like home. Mom has been here three years and she's never been happier.",
    name: "Linda T.",
    role: "Daughter of resident",
  },
  {
    quote: "They don't just care for Mama — they treat her with so much love and dignity. We finally sleep at night.",
    name: "The Reyes Family",
    role: "Family of resident",
  },
  {
    quote: "The staff knows my grandmother's stories, her favorite songs, even her sweet tooth. That's not care — that's family.",
    name: "Maria H.",
    role: "Granddaughter of resident",
  },
];

const Stars = () => (
  <div className="flex gap-1 mb-4">
    {[0, 1, 2, 3, 4].map((i) => (
      <svg key={i} className="w-4 h-4 fill-[#a8c8e8]" viewBox="0 0 24 24">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z" />
      </svg>
    ))}
  </div>
);

const TestimonialsSection = () => {
  return (
    <section id="testimonials" className="bg-[color:var(--hc-cream)]" data-testid="testimonials-section">
      <div className="container-hc py-20 md:py-28">
        <div className="text-center max-w-3xl mx-auto">
          <div className="text-xs font-bold tracking-[0.25em] text-[color:var(--hc-coral)]">
            FROM OUR FAMILIES
          </div>
          <h2 className="font-serif-display mt-5 text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[color:var(--hc-navy)]">
            Real words from the people who matter most.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white rounded-3xl p-7 shadow-md border border-black/[0.04] flex flex-col"
              data-testid={`testimonial-${i}`}
            >
              <Stars />
              <p className="italic font-serif-display text-xl leading-relaxed text-[color:var(--hc-navy)]/85 flex-1">
                "{t.quote}"
              </p>
              <div className="mt-6 pt-5 border-t border-[color:var(--hc-navy)]/10">
                <div className="font-semibold text-[color:var(--hc-navy)]">{t.name}</div>
                <div className="text-sm text-[color:var(--hc-navy)]/60">{t.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
